// import { set } from '@/utils/vuex'

export default {
  setCategoryList: (state, list) => {
    state.list = list;

    // Set byName data
    let byName = {};
    state.list.forEach(cat => {
      byName[cat.name] = cat;
    });
    state.byName = byName;
  },
  setCategoryListAdmin: (state, list) => {
    state.listAdmin = list;
  }
};
